<template>
  <div class="w-full px-4 py-20 md:py-25 max-w-screen md:px-10">
    <slot></slot>
  </div>
</template>
